<div class="account-switch-dialog" [class.loading]="isLoading" [attr.aria-busy]="isLoading">
  <div class="dialog-header">
    <div class="status-icon">
      <i class="pi pi-ban"></i>
    </div>
    <div class="header-text">
      <p class="title">{{ getTitle() }}</p>
      <p class="subtitle">{{ getMessage() }}</p>
    </div>
  </div>

  @if (currentAccount) {
    <div class="section">
      <p class="section-label">{{ texts.AccountSwitchSectionSignedInAs }}</p>
      <div class="current-account">
        <div class="avatar">
          <i class="pi pi-user"></i>
        </div>
        <div class="account-details">
          <span class="email">{{ currentAccount.email }}</span>
          <span class="tenant">{{ currentAccount.tenantId }}</span>
        </div>
      </div>
    </div>
  }

  <div class="section">
    <p class="section-label">{{ texts.AccountSwitchSectionOptions }}</p>
    <div class="action-list">
      <button
        type="button"
        class="action-card"
        (click)="onSwitchAccount()"
        [disabled]="isLoading"
        [attr.aria-label]="texts.AccountSwitchActionSwitch"
      >
        <div class="action-icon">
          <i class="pi pi-refresh"></i>
        </div>
        <div class="action-text">
          <span class="action-title">{{ texts.AccountSwitchActionSwitch }}</span>
          <span class="action-description">{{ texts.AccountSwitchActionSwitchDescription }}</span>
        </div>
      </button>

      <button
        type="button"
        class="action-card"
        (click)="onFreshLogin()"
        [disabled]="isLoading"
        [attr.aria-label]="texts.AccountSwitchActionFreshLogin"
      >
        <div class="action-icon">
          <i class="pi pi-sign-in"></i>
        </div>
        <div class="action-text">
          <span class="action-title">{{ texts.AccountSwitchActionFreshLogin }}</span>
          <span class="action-description">{{ texts.AccountSwitchActionFreshLoginDescription }}</span>
        </div>
      </button>

      <button
        type="button"
        class="action-card"
        (click)="onLogoutAndRestart()"
        [disabled]="isLoading"
        [attr.aria-label]="texts.AccountSwitchActionLogout"
      >
        <div class="action-icon">
          <i class="pi pi-sign-out"></i>
        </div>
        <div class="action-text">
          <span class="action-title">{{ texts.AccountSwitchActionLogout }}</span>
          <span class="action-description">{{ texts.AccountSwitchActionLogoutDescription }}</span>
        </div>
      </button>

      <button
        type="button"
        class="action-card"
        (click)="onSelectTenant()"
        [disabled]="isLoading"
        [attr.aria-label]="texts.AccountSwitchActionSelectTenant"
      >
        <div class="action-icon">
          <i class="pi pi-building"></i>
        </div>
        <div class="action-text">
          <span class="action-title">{{ texts.AccountSwitchActionSelectTenant }}</span>
          <span class="action-description">{{ texts.AccountSwitchActionSelectTenantDescription }}</span>
        </div>
      </button>
    </div>
  </div>

  <p-divider></p-divider>

  <div class="dialog-footer">
    <i class="pi pi-info-circle"></i>
    <div class="footer-text">
      <span>{{ texts.AccountSwitchFooterLineOne }}</span>
      <span>{{ texts.AccountSwitchFooterLineTwo }}</span>
    </div>
  </div>
</div>
